<template>
  <v-app class="background">
    <div v-if="!hideNavDrawer.includes($route.name)">
      <NavDrawer
        v-if="!(hideNavDrawerOnMobile.includes($route.name) && $vuetify.breakpoint.smAndDown)"
      />
      <NavDrawer
        v-else
        :permanent="false"
        temporary
        :value="$store.state.mobileNavDrawerOpen"
        @input="$store.commit('SET_MOBILE_NAV_DRAWER_OPEN', $event)"
      />
    </div>

    <v-main class="background">
      <div v-if="showLoader">
        <template>
          <div class="d-flex align-center justify-center flex-column" style="height: 100vh;">
            <bubble-loader/>
          </div>
        </template>
      </div>

<!-- 
      <v-app-bar elevation="0" class="ml-8 mr-4 mt-4 transparent d-flex rounded-xl" v-if="this.$route.name != 'login'">

        {{$store.state.breadcrumb}}
        
        <v-icon>mdi-chevron-down</v-icon>

        


        <p style="color: #FBF5F2;">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis magnam fugit amet
          quam nemo provident minima soluta. Quam, eius voluptatem voluptate aliquid vero ghi </p>


        <v-icon class="pa-2">mdi-bell-outline</v-icon>






        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on" text icon>
              <v-avatar>
                <v-icon class="pa-2">mdi-account-outline</v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <v-btn @click="logout">logout</v-btn>
        </v-menu>

      </v-app-bar> -->

      <router-view v-else> </router-view>
    </v-main>
  </v-app>
</template>




<script>

import NavDrawer from "./components/NavDrawer.vue";
import AuthService from "./services/AuthService";
CKEDITOR.plugins.addExternal('ckeditor_wiris', 'https://www.wiris.net/demo/plugins/ckeditor/', 'plugin.js');
import BubbleLoader from '@/components/BubbleLoader.vue';
import "./styles.css"
import keycloakMixin from "@/mixins/keycloakAuthMixin.js";


export default {
  name: "App",
  components: {
    NavDrawer,
    BubbleLoader
  },
  data() {
    return {
      drawer: false,
      mini: false,
      isLoggedIn: false,
      role: "",
      loginInfo: {},
      index: 0,
      showLoader:false,
      hideNavDrawer:["ResetPasswordView","ForgetPassword","InvitedLogin","login","InterviewNotActive"],
      hideNavDrawerOnMobile:["InterveiweeList","InterviewFeedbackForm","TestReport","DemoReport","InterviewReport"]
    }

  },
  methods: {
      logout() {
      AuthService.logout();
      this.$router.push("/login");
      },
      
  },
    async mounted() {
      if(this.$route.path.includes('state') && this.$route.path.includes('code')){
        this.showLoader = true;
        await keycloakMixin.methods.initializeAuth(this.$route.path);
        this.showLoader = false;
      }
      google.charts.load('current', {
      packages: ['corechart']
    });
  },
  beforeDestroy(){
       this.showLoader=false;
  },
  

  
};
</script>

<style>
.bgfont{
  font-family: graphikItalic !important;
}
</style>
